import { ColDef, ColGroupDef, GridApi, IRowNode } from "ag-grid-community";
import { Button } from "react-bootstrap";

export function getPreferredBrandsStockLevelConfig(totalRows: number, updateRedux: ()=> void): (ColDef<any> | ColGroupDef<any>)[]| null{
    return [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Rank",
            minWidth: 300,
            flex: 2,
            field: "rank",
            sort: "asc",        
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {                        
                        children: 
                            <div className="d-flex">
                                <div className="ps-1 pe-3">{params.data?.rank}</div>
                                <div className="rank-actions">
                                    {params.data!.rank < totalRows ? (
                                        <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => {moveManufacturer(params.api, params.data!.rank, true);   updateRedux();}}>
                                            <i className="uil-arrow-down"></i>
                                        </Button>
                                    ) : null
                                    }
                                    {params.data!.rank > 1 ? (
                                        <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => {moveManufacturer(params.api, params.data!.rank, false);   updateRedux();}}>
                                            <i className="uil-arrow-up"></i>
                                        </Button>
                                    ) : null
                                    }
                                </div>
                            </div>
                        }
                }          
            }
        },
        {
            headerName: "Name",
            field: "name",
            flex: 5,
            minWidth: 800,
        },
        {           
            field: "genericCategoryId",
            hide: true
        },
        {           
            field: "productId",
            hide: true
        },
                {           
            field: "dispenseName",
            hide: true
        },
    ]
}

function moveManufacturer(api :GridApi<any>, rank: number, moveDown: boolean) {
    console.log(api.getRowNode("3"));
    let rowBeingModified: IRowNode<any> | undefined = undefined;
    let rowAfterBeingModified: IRowNode<any> | undefined = undefined;
    let rowBeingSwitchedName = "";
    let rowBeingSwitchedDispenseName = "";
    let rowBeingSwitchedGenericCategoryId = "";
    let rowBeingSwitchedProductId = 0;

    api.forEachNode(node => {
        if (node.data.rank == rank){
            rowBeingModified = node;               
        }
        if ((node.data.rank == (rank+1) && moveDown == true) || (node.data.rank == (rank-1) && moveDown == false)){
            rowAfterBeingModified = node;
            rowBeingSwitchedName = node.data.name;
            rowBeingSwitchedDispenseName = node.data.dispenseName;
            rowBeingSwitchedGenericCategoryId = node.data.genericCategoryId;
            rowBeingSwitchedProductId = node.data.productId;
            rowBeingSwitchedDispenseName = node.data.DispenseName
        }
       
    });
    if(rowBeingModified != undefined && rowAfterBeingModified != undefined){
        (rowAfterBeingModified as IRowNode<any>).setDataValue("name", (rowBeingModified as IRowNode<any>).data.name); 
        (rowAfterBeingModified as IRowNode<any>).setDataValue("genericCategoryId", (rowBeingModified as IRowNode<any>).data.genericCategoryId); 
        (rowAfterBeingModified as IRowNode<any>).setDataValue("dispenseName", (rowBeingModified as IRowNode<any>).data.dispenseName); 
        (rowAfterBeingModified as IRowNode<any>).setDataValue("productId", (rowBeingModified as IRowNode<any>).data.productId); 
        (rowBeingModified as IRowNode<any>).setDataValue("name", rowBeingSwitchedName);
        (rowBeingModified as IRowNode<any>).setDataValue("genericCategoryId", rowBeingSwitchedGenericCategoryId);
        (rowBeingModified as IRowNode<any>).setDataValue("dispenseName", rowBeingSwitchedDispenseName);
        (rowBeingModified as IRowNode<any>).setDataValue("productId", rowBeingSwitchedProductId);
    }
    
    if(api.isQuickFilterPresent() == true){
        const filter = api.getQuickFilter();
        api.setGridOption('quickFilterText', "");
        api.setGridOption('quickFilterText', filter);
    }      
}